module.exports = __webpack_public_path__ + "static/media/Nodata.682793da.png";